import { useEffect, useState } from "react";
import { useLocation } from "react-router";
import AdminPage from "../../components/AdminPage";
import TableComponent from "../../components/adminTableComponent";
import DeleteModalContent from "../../components/DeleteModalContent/DeleteModalContent";
import { LoaderWrapper } from "../../components/LoaderWrapper";
import ModalWrapper from "../../components/ModalWrapper/ModalWrapper";
import { SpecificView } from "../../components/SpecificView/SpecificView";
import { loadDegrees } from "../Degrees/loadData";
import { loadMajors } from "../Major/loadData";
import { AddEducationEssentials } from "./addEducationEssentials";
import { loadLookupsList, loadLookupsTypes } from "./loadData";
import { lookupListHeaders } from "./tableHeaders";

const EducationEssentials = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [lookupsList, setLookupsList] = useState([]);
  const [lookupsTypes, setLookupsTypes] = useState([]);
  const [opened, setOpened] = useState(false);
  const [update, setUpdate] = useState(false);

  const [viewModalState, setViewModalState] = useState(false);
  const [viewModalData, setViewModalData] = useState({});
  const [majors, setMajors] = useState([]);
  const [degrees, setDegrees] = useState([]);
  const [editData, setEditData] = useState({});
  const [deleteData, setDeleteData] = useState({});
  const [deleteModalState, setDeleteModalState] = useState(false);
  const [editModalState, setEditModalState] = useState(false);
  console.log(editData, "editData");
  console.log(deleteData, "deleteData");
  console.log("lookupsList", lookupsList);
  console.log("lookupsTypes", lookupsTypes);
  console.log("majors", majors);
  console.log("degrees", degrees);
  useEffect(() => {
    loadLookupsList(setLoading).then(setLookupsList);
    loadLookupsTypes(setLoading).then(setLookupsTypes);
    loadMajors(setLoading).then(setMajors);
    loadDegrees(setLoading).then(setDegrees);
  }, [location.pathname, update]);

  const filteredLookupsList = lookupsList?.filter(
    (lookup) =>
      lookup.lookupType === "state" ||
      lookup.lookupType === "schoolType" ||
      lookup.lookupType === "school" ||
      lookup.lookupType === "minor" ||
      lookup.lookupType === "major"
  );
  console.log("filteredLookupsList", filteredLookupsList);
  let newLookupsTypes = ["degree", "major"];
  const filteredLookupsTypes = lookupsTypes?.filter(
    (lookupType) =>
      lookupType === "state" ||
      lookupType === "schoolType" ||
      lookupType === "school" ||
      lookupType === "minor"
  );
  filteredLookupsTypes.push(...newLookupsTypes);
  console.log("OUR FILTERED LOOKUPS TYPES", filteredLookupsTypes);
  console.log("OUR FILTERED LOOKUPS", lookupsTypes);
  const alldegrees = degrees?.map((degree) => ({
    lookupName: degree.degreeName,
    lookupType: "degree",
    _id: degree._id,
    lookupDescription: degree.degreeNote,
    createdDate: degree.createdDate,
    state: degree.state,
  }));
  const allMajors = majors?.map((major) => ({
    lookupName: major.majorName,
    lookupType: "major",
    _id: major._id,
    lookupDescription: major.majorDescription,
    createdDate: major.createdDate,
    state: major.state,
  }));
  const allLookups = [...filteredLookupsList, ...alldegrees, ...allMajors];
  allLookups.map((lookup, index) => {
    lookup.id = index + 1;
  });
  let url = "";
  if (deleteData?.lookupType === "major") {
    url = `major/deleteMajor/${deleteData?._id}`;
  } else if (deleteData?.lookupType === "degree") {
    url = `degree/deleteDegree/${deleteData?._id}`;
  } else if (
    deleteData?.lookupType !== "major" &&
    deleteData?.lookupName !== "degree"
  ) {
    url = `lookup/deleteLookup/${deleteData?._id}`;
  }

  return (
    <AdminPage title={"Education Essentials"}>
      <ModalWrapper
        opened={viewModalState}
        setOpened={setViewModalState}
        title={"Education Essential Details"}
        InternalComponent={
          <SpecificView
            name={viewModalData?.lookupName}
            type={viewModalData?.lookupType}
            date={viewModalData?.createdDate}
            description={viewModalData?.lookupDescription}
            status={viewModalData?.state}
          />
        }
      />
      <ModalWrapper
        opened={deleteModalState}
        setOpened={setDeleteModalState}
        title={"Delete Education Essential"}
        InternalComponent={
          <DeleteModalContent
            route={url}
            type={"Education Essential"}
            setUpdate={setUpdate}
            setOpened={setDeleteModalState}
            setLoading={setLoading}
          />
        }
      />
      <AddEducationEssentials
        opened={opened}
        setOpened={setOpened}
        setUpdate={setUpdate}
        lookupsTypes={filteredLookupsTypes}
        editData={editData}
        setEditData={setEditData}
        setEditModalState={setEditModalState}
        editModalState={editModalState}
        setLoading={setLoading}
      />
      <LoaderWrapper loading={loading}>
        <TableComponent
          headCells={lookupListHeaders}
          rowData={allLookups}
          opened={opened}
          setOpened={setOpened}
          showAddButton={true}
          setViewModalState={setViewModalState}
          setViewModalData={setViewModalData}
          setEditData={setEditData}
          setEditModalState={setEditModalState}
          setDeleteData={setDeleteData}
          setDeleteModalState={setDeleteModalState}
        />
      </LoaderWrapper>
    </AdminPage>
  );
};

export default EducationEssentials;
